// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Recommendation.scss
// module id = 655
// module chunks = 22 88